<script>
    import Loader from '../Loader.svelte';
    import { addFormModal } from '../../Forms/ModalFormManager.svelte';
    import FrameworkReference from '../../Models/frameworkReferenceModel';
    import SortableTable from '../SortableTable.svelte';
    import { notifier } from "@beyonk/svelte-notifications";
    import {confirm} from '../Confirmation.svelte';
    import ImportModal from '../Libraries/ImportModal.svelte';
    import {addModal} from '../ModalManager.svelte';
    import parseCSV, {generateCSV} from '../../lib/csv';
    import Field from '../../Forms/Field.svelte';
    import { downloadFile } from '../../Utilities/util';
    import {db} from '../../Database.svelte';
    import { handleError } from '../../Utilities/handlePromise';

    export let params;
    let fields;

    let formData = {};

    function addReference(evt) {
        let form  = evt.target;

        $framework.references.addChild(formData);
        form.reset();
        formData = {};
    }

    function editReference(ref) {
        addFormModal({
            fields: fields.formFields,
            data: ref.details
        }).then(formData => {
            ref.save(formData).then(() => notifier.success("Reference Saved"));
        }, handleError);
    }

    function deleteReference(ref) {
        confirm(`Are you sure you want to delete ${ref.details.name}?`).then(() => {
            ref.delete().then(() => {
                notifier.success("Reference Deleted")
            }, handleError)
        }, handleError)
    }

    function exportItems() {
        let header_fields = ["_id", ...fields.formFields.map(f => f.name)];
        let field_defs = Object.fromEntries(fields.formFields.map(f => [f.name, f]));

        let data = [...$framework.references].map(ref => header_fields.map(field => {
            if (typeof ref.details[field] == "string") {
                return ref.details[field];
            } else if (!ref.details[field]) {
                return "";
            } else {
                if (field_defs[field].type == "customTags") {
                    return JSON.stringify(ref.details[field].map(t => t.name)).slice(1, -1);
                } else if (field_defs[field].type == "referenceLibrary") {
                    return JSON.stringify(ref.details[field].map(t => {return {framework: t.framework, control: t.name}}))
                } else {
                    return JSON.stringify(ref.details[field]);
                }
            }
        }))

        console.log(header_fields, data);

        let csv = generateCSV(header_fields, data);

        downloadFile(csv, `${$framework.details.name}_export.csv`, "text/csv");
    }

    function importItems() {
        let headers = fields.formFields.map(f => f.name);
        addModal(ImportModal, {
            headers,
            libraryName: $framework.details.name,
            title: "Import References",
            fields: [{
                type: "file",
                name: "import",
                label: "Import File"
            }]
        }).then((formData) => {
            formData.import.item(0).text().then(async csv => {
                let rows = parseCSV(csv);

                if (rows[0][0] == "_id") {
                    if (JSON.stringify(rows[0].slice(1)) !== JSON.stringify(headers)) {
                        notifier.danger("Incorrect Import Format");
                        return;
                    }
                } else {
                    if (JSON.stringify(rows[0]) !== JSON.stringify(headers)) {
                        notifier.danger("Incorrect Import Format");
                        return;
                    }
                }

                let promises = [];
                // start with row 1 to skip header row
                for (let row of rows.slice(1)) {
                    // handle blank row
                    if (!row[0]) continue;

                    let doc = {};

                    if (rows[0][0] == "_id") {
                        doc = await db.get(row[0]);
                        row = row.slice(1);
                    }

                    fields.formFields.forEach((field, i) => {
                        if (field.type == "tags") {
                            doc[field.name] =  row[i] ? row[i].split(',').map(s => s.trim()) : [];
                        } else {
                            doc[field.name] = row[i];
                        }
                    });

                    if (rows[0][0] == "_id") {
                        promises.push(db.put(doc));
                    } else {
                        promises.push($framework.references.addChild(doc));
                    }
                }

                Promise.all(promises).then(() => {
                    notifier.success("References Imported");
                })
            })
        }, handleError);
    }

    $: framework = FrameworkReference.getStore(params.id);
    $: {
        if ($framework) {
            fields = FrameworkReference.parseReferenceFields([...$framework.fields])
        }
    }
</script>

<Loader loading={!$framework}>
    <div class="container is-fluid">
        <h1 class="title is-1">
            {$framework.details.name}
            <a href="#/frameworkReference" class="button is-pulled-right">Close</a>
        </h1>

        <form on:submit|preventDefault={addReference}>
            <SortableTable sortFields={fields.sortFields} tableData={[...$framework.references]} showHideFields={false} ORM={true}>
                <div slot="rowActions" let:row={reference}>
                    <div class="button is-info" on:click={() => editReference(reference)}>Edit</div>
                    <div class="button is-danger" on:click={() => deleteReference(reference)}>Delete</div>
                </div>
                <tr slot="bottomRow">
                        {#each fields.formFields as field (field.name)}
                        <td><Field {...field} label="" bind:value={formData[field.name]}></Field></td>
                        {/each}
                        <td><button class="button is-success">Add Reference</button>

                </tr>
                <div slot="footerActions">
                    <div class="button" on:click={exportItems}>Export</div>
                    <div class="button" on:click={importItems}>Import</div>
                </div>
            </SortableTable>
        </form>
    </div>
</Loader>